module.exports = __webpack_public_path__ + "media/images/product_lines/car/info-41a0bafd53eab44eddd34229c5620a5a.svg";